define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 编辑展示模式。
     *
     * @exports EnumEditMode
     * 
     * @see SightLineAnalysis#editMode
     */
    var EnumEditMode = {
        /**
         * 展示模式。
         * @type {String}
         * @constant
         */
        SHOW: "SHOW",

        /**
         * 编辑模式。
         * @type {String}
         * @constant
         */
        EDIT: "EDIT"
    }
    freezeObject(EnumEditMode)

    /**
     * 反向查找编辑展示模式的名称。
     * 
     * @param {Number} value 编辑展示模式的数值。
     * @returns {String} 编辑展示模式的名称。
     */
    function getName(value) {
        for (var key in EnumEditMode) {
            if (EnumEditMode.hasOwnProperty(key) && EnumEditMode[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        SHOW: "SHOW",
        EDIT: "EDIT",
        getName: getName
    }
})